
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'

@Component({
  name: 'package',
  components: {}
})
export default class extends Vue {
  @Prop() campus_info_id: string
  @Prop() is_show_campus_info: boolean

  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  list: any = []
  dialog: boolean = false
  info: any = {
    name: '',
    is_enabled: 0
  }
  campus_id: any = ''
  allData: any = {}
  is_add: boolean = false
  item_id: string = ''
  p_hight: any = window.innerHeight - 100 + 'px'



  @Watch('is_show_campus_info')
  getId(newVal, oldVal) {
    this.campus_id = this.campus_info_id
    this.getList()
    this.getHeight()
  }
  getHeight() {
    window.onresize = () => {
      this.p_hight = window.innerHeight - 100 + 'px'
    }
  }
  close() {
    this.$emit('close-campus', false)
  }

  async getList() {
    const res: any = await UserModule.campusDetails({ campus_id: this.campus_id })
    if (res.code === 200) {
      this.list = res.data.classroom
      this.allData = res.data
    }
  }

  async getDelete(val) {
    const res: any = await UserModule.deleteCampusClassroom({ id: val.id })
    if (res.code === 200) {
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
      this.getList()
    } else {
      this.$message.error('删除失败！')
    }
  }

  deleteRow(val) {
    this.$confirm('此操作将永久删除该教室, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.getDelete(val)
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
  add() {
    this.is_add = true
    this.dialog = true
  }
  edit(val) {
    this.item_id = val.id
    this.info.name = val.name
    this.info.is_enabled = val.is_enabled
    this.is_add = false
    this.dialog = true
  }
  dialogClose() {
    this.dialog = false
  }
  async dialogTrue() {
    let data = {
      campus_id: this.campus_id,
      name: this.info.name,
      is_enabled: this.info.is_enabled
    }

    if (this.is_add) {
      const res: any = await UserModule.addCampusClassroom(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '新建成功!'
        })
        this.dialog = false
        this.getList()
      } else {
        this.$message.error('新增失败！')
      }
    } else {
      data['id'] = this.item_id
      const res: any = await UserModule.editCampusClassroom(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '编辑成功!'
        })
        this.dialog = false
        this.getList()
      } else {
        this.$message.error('编辑失败！')
      }
    }
  }


  mounted() {
    
  }
}
